import { render, staticRenderFns } from "./BuyingFuelView.vue?vue&type=template&id=e6487a4e&"
import script from "./BuyingFuelView.vue?vue&type=script&lang=js&"
export * from "./BuyingFuelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports